import { useRef } from "react";
import { capturePointer } from "../../lib/pointer";

// Rotary knob: drag up/down or use arrow keys.
export const Knob = ({ value, min = 0, max = 1, onChange, label, testId, color = "#facc15", size = 26, fmt }) => {
  const start = useRef(null);
  const frac = (value - min) / (max - min);
  const clamp = (v) => Math.max(min, Math.min(max, Math.round(v * 100) / 100));
  const down = (e) => {
    e.preventDefault();
    capturePointer(e.currentTarget, e.pointerId);
    start.current = { y: e.clientY, v: value };
  };
  const move = (e) => {
    if (!start.current || !e.currentTarget.hasPointerCapture(e.pointerId)) return;
    onChange(clamp(start.current.v + ((start.current.y - e.clientY) / 120) * (max - min)));
  };
  const key = (e) => {
    const s = (max - min) / 24;
    if (e.key === "ArrowUp" || e.key === "ArrowRight") { e.preventDefault(); onChange(clamp(value + s)); }
    if (e.key === "ArrowDown" || e.key === "ArrowLeft") { e.preventDefault(); onChange(clamp(value - s)); }
  };
  const angle = -135 + frac * 270;
  return (
    <div className="flex flex-col items-center gap-0.5 select-none" title={`${label}: ${fmt ? fmt(value) : value}`}>
      <div
        role="slider" tabIndex={0} aria-label={label} aria-valuenow={value} aria-valuemin={min} aria-valuemax={max}
        data-testid={testId}
        onPointerDown={down} onPointerMove={move} onPointerUp={() => (start.current = null)} onKeyDown={key}
        onDoubleClick={() => onChange(min < 0 ? 0 : min)}
        className="relative rounded-full border border-black bg-gradient-to-b from-zinc-600 to-zinc-900 shadow cursor-ns-resize touch-none focus:outline-none focus:ring-1 focus:ring-yellow-400"
        style={{ width: size, height: size }}
      >
        <span className="absolute left-1/2 top-1/2 h-[42%] w-[2px] -translate-x-1/2 origin-bottom rounded"
          style={{ background: color, transform: `translate(-50%, -100%) rotate(${angle}deg)` }} />
      </div>
      <span className="mono text-[8px] uppercase tracking-wider text-zinc-500">{label}</span>
    </div>
  );
};
